import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'componentsV2/Icon';
import style from './Modal.module.scss';

const Modal = ({
  children,
  theme = {},
  showModal = false,
  onClickCloseModal,
  onClickModalOverlay,
  closeIconColor = 'black',
}) => {
  if (!children || !showModal) return null;
  return (
    <div
      className={classNames(style.modalOverlay, theme.modalOverlay)}
      onClick={onClickModalOverlay}
    >
      <div className={classNames(style.modalContent, theme.modalContent)}>
        <div className={classNames(style.closeIconContainer, theme.closeIconContainer)}>
          <button onClick={onClickCloseModal} tabIndex={0} aria-label="Close Modal">
            <Icon icon="close" color={closeIconColor} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.shape({}),
  showModal: PropTypes.bool,
  onClickCloseModal: PropTypes.func,
  onClickModalOverlay: PropTypes.func,
  closeIconColor: PropTypes.string,
};

export default Modal;
